import classNames from "classnames";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useContext } from "react";
import { toast } from "react-toastify";
import { IBoardTreePageDto } from "../../app/models/dto";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import DownloadErrorToast from "../toast/DownloadErrorToast";

interface IParams {
  board: IBoardTreePageDto;
  tenant: ITenant;
}

const SaveOfflineBoardButton: React.FC<IParams> = ({ board, tenant }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    saveBoardToDb,
    currentDownloadingBoardId,
    setCurrentDownloadingBoardId,
    isDownloadInProgress,
    alreadyDownloadedBoardIds,
    addAlreadyDownloadedBoards,
  } = rootStore.offlineStore;

  const handleClick = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    if (!isDownloadInProgress) {
      setCurrentDownloadingBoardId(board.boardId);
      await saveBoardToDb(board, tenant)
        .then(() => addAlreadyDownloadedBoards(board))
        .catch(() => {})
        .finally(() => setCurrentDownloadingBoardId(null));
    } else
      toast.error(
        (props) =>
          DownloadErrorToast({
            type: "inProgress",
            toastContentProps: props,
          }),
        { toastId: `DownloadInProgress` }
      );
  };

  const getIconClassNames = () => {
    if (currentDownloadingBoardId === board.boardId) return "fa-spinner fa-spin";
    else if (alreadyDownloadedBoardIds.has(board.boardId)) {
      const savedDate = alreadyDownloadedBoardIds.get(board.boardId);
      if (savedDate && moment(savedDate).isBefore(board.lastUpdateDate, "minute"))
        return "fa-exclamation-triangle text-warning";
      else return "fa-check text-success";
    } else return "fa-cloud-download-alt";
  };

  return (
    <i
      className={classNames("fas fa-lg salvaOffline-board ml-2", getIconClassNames())}
      onClick={(e) => handleClick(e)}
    ></i>
  );
};

export default observer(SaveOfflineBoardButton);
